import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import CareersPage from "./pages/CareersPage";
import DSPApplicationPage from "./pages/DSPApplicationPage";
import CNAApplicationPage from "./pages/CNAApplicationPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import EMRPage from "./pages/EMRPage";
import TenantOnboarding from "./components/TenantOnboarding";
import AccountSuspended from "./components/AccountSuspended";
import BillingPlans from "./components/BillingPlans";
import BillingSuccess from "./components/BillingSuccess";
import ReferrerPortal from "./components/ReferrerPortal";
import CharlieWidget from "./components/CharlieWidget";
import { PWAInstallPrompt, OfflineIndicator } from "./components/PWAComponents";
import { Toaster } from "./components/ui/sonner";

// Account Suspended Page Wrapper
function AccountSuspendedPage() {
  const errorData = JSON.parse(sessionStorage.getItem('subscription_error') || '{}');
  return (
    <AccountSuspended 
      reason={errorData.reason}
      message={errorData.message}
      tenantName={errorData.tenant_name}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <OfflineIndicator />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/dsp" element={<DSPApplicationPage />} />
          <Route path="/careers/cna" element={<CNAApplicationPage />} />
          <Route path="/portal" element={<LoginPage />} />
          <Route path="/login" element={<Navigate to="/portal" replace />} />
          <Route path="/register" element={<TenantOnboarding />} />
          <Route path="/signup" element={<Navigate to="/register" replace />} />
          <Route path="/account-suspended" element={<AccountSuspendedPage />} />
          <Route path="/billing/plans" element={<BillingPlans />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="/referrer-portal" element={<ReferrerPortal />} />
          <Route path="/partner" element={<Navigate to="/referrer-portal" replace />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/emr/:clientId"
            element={
              <ProtectedRoute>
                <EMRPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <CharlieWidget />
        <PWAInstallPrompt />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;